// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import * as ppa from './api/ppa'



// thunks
export const fetchAllReportsByAccount = createAsyncThunk('report/getAllReportsByAccount', async accountUUID => {
    const response = await ppa.getAllReportsByAccount(accountUUID);
    return response.data
});

export const createReport = createAsyncThunk('report/createReport', async payload => {
    const response = await ppa.sendReport(payload);
    return response.data
});

export const fetchReport = createAsyncThunk('report/fetchReport', async reportUUID => {
    const response = await ppa.getReport(reportUUID);
    return response.data
});

export const updateReport = createAsyncThunk('report/updateReport', async payload => {
    const response = await ppa.setReport(payload);
    return response.data
})

export const deleteReport = createAsyncThunk('report/deleteReport', async reportUUID => {
    const response = await ppa.removeReport(reportUUID);
    return response.data
})

export const downloadReport = createAsyncThunk('report/downloadReport', async reportUUID => {
    const response = await ppa.downloadReport(reportUUID);
    let filename;
    if(response.headers['content-disposition']) {
        filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()
    } else {
        const uuid = crypto.randomUUID();
        let suffix = response.headers['content-type']==="text/csv" ? '.csv' : '.xlsx';
        filename = uuid + suffix;
    }
    return ({ data: response.data, filename })
})

export const getPreviewReport = createAsyncThunk('report/getPreviewReport', async payload => {
    const format = payload.schedule?.format
    if (format === 'JSON') {
        const response = await ppa.getPreviewReport(payload);
        return response.data
    } else if (format === 'CSV') {
        const response = await ppa.getPreviewFile(payload);
        const filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()

        return ({ data: response.data, filename })
    }
    else if (format === 'XLSX') {
        const response = await ppa.getPreviewFile(payload);
        const filename = response.headers['content-disposition']
            .split(';')
            .find(part => part.includes('filename'))
            .replace('filename=', '')
            .trim();

        // Ensure the file extension is .xlsx
        const adjustedFilename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
        return ({ data: response.data, filename: adjustedFilename });
    }
})
